import {
  OrganizationMetricsEmployee,
  OrganizationMetricsEmployeeConfigType,
  OrganizationMetricsTaskConfigType,
  OrganizationMetricsTaskType,
} from './types'

export const OrganizationMetricsEmployeeConfig: Record<
  OrganizationMetricsEmployee,
  OrganizationMetricsEmployeeConfigType
> = {
  community_manager: {
    hourlyRate: 20.42,
    appKey: 'socialMediaManager',
  },
  executive_assistant: {
    hourlyRate: 23.54,
    appKey: 'executiveAssistantV2',
  },
  content_writer: {
    hourlyRate: 22.03,
    appKey: 'contentCreator',
  },
  sales_outbound: {
    hourlyRate: 17.88,
    appKey: 'salesAssistant',
  },
}

export const OrganizationMetricsTaskConfig: Record<
  OrganizationMetricsTaskType,
  OrganizationMetricsTaskConfigType
> = {
  email_processed: {
    labels: {
      singular: 'Email Processed',
      plural: 'Emails Processed',
    },
    labelUnit: 'email',
    timeEstimate: 0.0055, // 20 sec
    employee: OrganizationMetricsEmployee.EXECUTIVE_ASSISTANT,
  },
  email_drafted: {
    labels: {
      singular: 'Email Drafted',
      plural: 'Emails Drafted',
    },
    labelUnit: 'draft',
    timeEstimate: 0.0833, // 5 min
    employee: OrganizationMetricsEmployee.EXECUTIVE_ASSISTANT,
  },
  social_post_drafted: {
    labels: {
      singular: 'Social Post Drafted',
      plural: 'Social Posts Drafted',
    },
    labelUnit: 'post',
    timeEstimate: 0.5, // 30 min
    employee: OrganizationMetricsEmployee.COMMUNITY_MANAGER,
  },
  blog_post_drafted: {
    labels: {
      singular: 'Blog Post Drafted',
      plural: 'Blog Posts Drafted',
    },
    labelUnit: 'post',
    timeEstimate: 1, // 60 min
    employee: OrganizationMetricsEmployee.CONTENT_WRITER,
  },
  lead_contacted: {
    labels: {
      singular: 'Lead Contacted',
      plural: 'Leads Contacted',
    },
    labelUnit: 'lead',
    timeEstimate: 0.0833, // 5 min
    employee: OrganizationMetricsEmployee.SALES_OUTBOUND,
  },
}
